import styles from './GameButtonsSkeleton.module.css';

export function GameButtonsSkeleton() {
  return (
    <div className={styles.actions_skeleton}>
      <div></div>
      <div></div>
    </div>
  );
}
